import { Component } from '@mycolorway/tao';
import marked from '../modules/marked';

Component('tr-markdown-parser', {
  properties: {
    content: {
      type: String,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  checkParsingTimer: null,

  init() {
    this.parseContent();
  },

  disconnected() {
    this.stopCheckParsing();
  },

  parseContent() {
    this.startCheckParsing();

    marked(this.content, (err, result) => {
      this.stopCheckParsing();

      if (!err) {
        this.querySelector('.parsed-content').innerHTML = `
          <tr-editor-output-renderer class="editor-style gallery-wrap">
            ${result}
          </tr-editor-output-renderer>
        `;
      }
    });
  },

  startCheckParsing() {
    this.checkParsingTimer = setTimeout(() => {
      this.loading = true;
    }, 200);
  },

  stopCheckParsing() {
    this.loading = false;

    if (this.checkParsingTimer) {
      clearTimeout(this.checkParsingTimer);
      this.checkParsingTimer = null;
    }
  },
});
